import React from 'react';
import { UtilityBar } from '../components/UtilityBar';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { ServicePathways } from '../components/ServicePathways';
import { WhyChoose } from '../components/WhyChoose';
import { HowItWorks } from '../components/HowItWorks';
import { Reviews } from '../components/Reviews';
import { ComplianceSafety } from '../components/ComplianceSafety';
import { ServiceArea } from '../components/ServiceArea';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { FloatingMobileCTA } from '../components/FloatingMobileCTA';
import { SocialProofToast } from '../components/SocialProofToast';
export function HomePage() {
  return <div className="min-h-screen bg-white font-body text-slate selection:bg-accent selection:text-white" data-id="element-546">
      <UtilityBar data-id="element-547" />
      <Header data-id="element-548" />
      <main data-id="element-549">
        <Hero data-id="element-550" />
        <ServicePathways data-id="element-551" />
        <WhyChoose data-id="element-552" />
        <HowItWorks data-id="element-553" />
        <Reviews data-id="element-554" />
        <ComplianceSafety data-id="element-555" />
        <ServiceArea data-id="element-556" />
        <FAQ data-id="element-557" />
        <FinalCTA data-id="element-558" />
      </main>
      <Footer data-id="element-559" />
      <FloatingMobileCTA data-id="element-560" />
      <SocialProofToast data-id="element-561" />
    </div>;
}